<div class="container">
  <div [ngClass]="login.contraste ? 'card-panel mt-5 fundo-contraste' : 'card-panel mt-5 fundo-normal'">
    <form [formGroup]="entidadeForm" autocomplete="off">
      <div class="row">
        <div class="col-6">
          <table>
            <td style="vertical-align: middle;"><img src="assets/img/global/licitacao.png" alt="" title="" width="42"
                height="42">
            </td>
            <td>
              <p
                [ngClass]="this.login.contraste ? 'titulo-txt-contraste fonte-acessibilidade m-0' : 'titulo-txt-normal fonte-acessibilidade m-0'">
                LICITAÇÕES</p>
              <p
                [ngClass]="this.login.contraste ? 'subtitulo-txt-contraste fonte-acessibilidade m-0' : 'subtitulo-txt-normal fonte-acessibilidade m-0'">
                EXERCÍCIO: {{login.exercicio.ano}} - {{login['ppa']['descricao']}}</p>
            </td>
          </table>
        </div>
        <div class="col-6">
          <button (click)="sair()" class="btn btn-sm btn-outline-secondary float-right ml-5">
            <img src="assets/img/global/cross.png" alt="sair" title="Sair" height="20" width="20">
          </button>
          <button (click)="voltar()" class="btn btn-sm btn-outline-secondary float-right">
            <img src="assets/img/global/table_sort_filter.png" alt="pesquisa" title="Voltar a pesquisar" height="22"
              width="22">
            Voltar
          </button>
        </div>
      </div>
      <hr [ngClass]="this.login.contraste ? 'linha-contraste mt-1 mb-1' : 'linha-normal mt-1 mb-1'" />
      <div class="row">
        <div class="col-9">
          <label
            [ngClass]="this.login.contraste ? 'text-white font-weight-bold mr-2 fonte-acessibilidade' : 'text-primary font-weight-bold mr-2 fonte-acessibilidade'">LICITAÇÃO
            Nº:</label>
          <label type="text" readonly id="numero_"
            [ngClass]="this.login.contraste ? 'text-white font-weight-bold ml-2 fonte-acessibilidade' : 'text-primary font-weight-bold ml-2 fonte-acessibilidade'">{{entidadeForm.get('numero').value}}</label>
        </div>
        <div class="col-3">

        </div>
      </div>
      <div class="row">
        <div class="col-md-8">
          <div class="row">
            <div class="form-group col-md-4">
              <label for="modalidade">Modalidade</label>
              <input value="{{entidadeForm.get('modalidade.nome').value}}" type="text"
                [ngClass]="this.login.contraste ? 'form-control-plaintext text-white' : 'form-control-plaintext'"
                id="modalidade">
            </div>
            <div class="form-group col-md-4">
              <label for="processo">Processo</label>
              <input value="{{entidadeForm.get('processo').value}}" type="text"
                [ngClass]="this.login.contraste ? 'form-control-plaintext text-white' : 'form-control-plaintext'"
                id="processo">
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-4">
              <label for="data_assinatura">Data Abertura</label>
              <input value="{{entidadeForm.get('data_abertura').value | date:'dd/MM/yyyy':'GMT'}}" type="text"
                [ngClass]="this.login.contraste ? 'form-control-plaintext text-white' : 'form-control-plaintext'"
                id="data_assinatura">
            </div>
            <div class="form-group col-md-4">
              <label for="data_termino">Data Homologação</label>
              <input value="{{entidadeForm.get('data_homologacao').value | date:'dd/MM/yyyy':'GMT'}}" type="text"
                [ngClass]="this.login.contraste ? 'form-control-plaintext text-white' : 'form-control-plaintext'"
                id="data_termino">
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-4 pb-0 mb-0">
              <label for="valor_contrato">Valor estimado<span class="text-danger">*</span></label>
              <input unmask="true" [imask]="imaskConfig" formControlName="valor_estimado" type="text"
                [ngClass]="this.login.contraste ? 'form-control-plaintext text-white' : 'form-control-plaintext'"
                id="valor_contrato" readonly placeholder="informe o valor" style="font-weight: bold; color: #1e88e5">
            </div>
          </div>
        </div>
      </div>
      <hr [ngClass]="this.login.contraste ? 'linha-contraste mt-1 mb-1' : 'linha-normal mt-1 mb-1'" />
      <div class="form-row">
        <div class="form-group col-12">
          <label for="objeto">Objeto</label>
          <textarea formControlName="objeto" readonly
            [ngClass]="this.login.contraste ? 'form-control-plaintext text-white' : 'form-control-plaintext'"
            id="objeto" rows="5"></textarea>
        </div>
      </div>
      <hr [ngClass]="this.login.contraste ? 'linha-contraste mt-1 mb-1' : 'linha-normal mt-1 mb-1'" />
      <ul class="nav nav-tabs" id="myTab" role="tablist">
        <li class="nav-item">
          <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home"
            aria-selected="true">Proponentes</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile"
            aria-selected="false">Memorial</a>
        </li>
      </ul>
      <div class="tab-content" id="myTabContent">
        <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
          <div class="row">
            <div class="col-md">
              <div class="table-responsive">
                <table
                  [ngClass]="login.contraste ? 'table table-dark fonte-acessibilidade' : 'table table-eddy fonte-acessibilidade'">
                  <thead>
                    <tr>
                      <th scope="col">CNPJ</th>
                      <th scope="col">Razão social</th>
                      <th scope="col">Endereço</th>
                      <th scope="col">Cidade</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of listaProponentes">
                      <td>{{item.favorecido.cpf_cnpj | CPF}}</td>
                      <td>{{item.favorecido.nome}}</td>
                      <td>{{item.favorecido.endereco}}</td>
                      <td>{{item.favorecido.municipio}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
          <div class="row">
            <div class="col-md">
              <div class="table-responsive">
                <table
                  [ngClass]="login.contraste ? 'table table-dark fonte-acessibilidade' : 'table table-eddy fonte-acessibilidade'">
                  <thead>
                    <tr>
                      <th style="width: 15%" scope="col">Quantidade</th>
                      <th style="width: 10%" scope="col">Unidade</th>
                      <th style="width: 70%" scope="col">Descrição</th>
                      <th style="width: 10%" scope="col"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of listaMemoriais">
                      <td>{{item.quantidade}}</td>
                      <td>{{item.unidade}}</td>
                      <td>{{item.descricao}}</td>
                      <td class="text-right">
                        <button (click)="abrirProposta(item)" type="button" data-toggle="modal"
                          title="Visualizar propostas" data-target="#dialogProposta" style="font-size: 11px"
                          class="btn btn-sm btn-outline-secondary mr-2">
                          <img src="assets/img/global/zoom.png" alt="Visualizar" height="18" width="18">
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <pre *ngIf="entidadeForm">{{ entidadeForm | json}}</pre> -->
    </form>
  </div>
</div>


<div class="modal fade" id="dialogProposta" tabindex="-1" role="dialog" aria-labelledby="proposta" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header bg-primary text-white">
        <h5 class="modal-title" id="title">Propostas</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-12">
            <span class="font-weight-bold">{{descricao}}</span>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-12">
            <table class="table table-eddy">
              <thead>
                <tr>
                  <th scope="col">Proponente</th>
                  <th class="text-right" scope="col">Quantidade</th>
                  <th class="text-right" scope="col">Unitário</th>
                  <th class="text-right" scope="col">Total</th>
                  <!-- <th scope="col">Situação</th> -->
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of listaPropostas">
                  <td>{{item.favorecido.nome}}</td>
                  <td class="text-right">{{item.quantidade | number:'1.2-2'}}</td>
                  <td class="text-right">{{item.valor_unitario | number:'1.2-2'}}</td>
                  <td class="text-right">{{item.valor_unitario | number:'1.2-2' }}</td>
                  <!-- <td>{{item.vencedor}}</!-->
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-link" id="btnCancelarUpload" data-dismiss="modal">Cancelar</button>
      </div>
    </div>
  </div>
</div>
